import { apiInterceptor, publicApiInterceptor } from "./api";
import { API_ENDPOINTS } from "@/config/apiEndpoints";

const loginApi = async (credentials: string): Promise<any> => {
  const response = await publicApiInterceptor.post(`${API_ENDPOINTS.AUTH.LOGIN}?${credentials}`);
  return response;
};

const simpleCreateUserApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.AUTH.USERS_SIMPLE_CREATE, data);
  return response;
};

const simpleUpdateUserApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.put(API_ENDPOINTS.AUTH.USERS_SIMPLE_UPDATE, data);
  return response;
};


const sendOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD_SEND_OTP, data);
  return response;
};


const signupApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.SIGNUP, data);
  return response;
};


const sendOtpToPhoneApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.SEND_OTP_TO_PHONE, data);
  return response;
};

const verifyMobileOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.VERIFY_MOBILE_OTP, data);
  return response;
};

const verifyOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.VERIFY_OTP, data);
  return response;
};


const getPhoneCodeApi = async (): Promise<any> => {
  const response = await publicApiInterceptor.get(API_ENDPOINTS.COMMON.PHONE_CODE);
  return response;
};


const resetPasswordApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, data);
  return response;
};


const resendOtpApi = async (data: any): Promise<any> => {
  const response = await publicApiInterceptor.post(API_ENDPOINTS.AUTH.RESEND_OTP, data);
  return response;
};


const getEventListApi = async (): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.EVENTS.GET_EVENT_LIST);
  return response;
};

const getServiceTypesApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.SERVICE_TYPES);
  return response;
};

const getCargoTypesApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.CARGO_TYPES);
  return response;
};

const getCarriersApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.CARRIERS);
  return response;
};

const createCarrierApi = async (payload: { carrier_lable: string; carrier_value: string }): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.COMMON.CARRIERS, payload);
  return response;
};

const createEnquiryApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.ENQUIRY.CREATE_ENQUIRY, data);
  return response;
};

const updateEnquiryApi = async (data: any, enquiry_id: string): Promise<any> => {
  const response = await apiInterceptor.put(`${API_ENDPOINTS.ENQUIRY.UPDATE_ENQUIRY.replace('{{enquiry_id}}', enquiry_id)}`, data);
  return response;
};

const updateDetailsApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.put(API_ENDPOINTS.AUTH.PROFILE_UPDATE, data);
  return response;
};

const getEnquiryByIdApiV2 = async (id: any): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.ENQUIRY.GET_ENQUIRY_BY_ID.replace('{{enquiry_id}}', id)}`);
  return response;
};

const getEnquiryMetaApi = async (id: any): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.ENQUIRY.GET_ENQUIRY_META.replace('{{enquiry_id}}', id)}`);
  return response;
};

const updateEnquiryMetaApi = async (data: any, enquiry_id: string): Promise<any> => {
  const response = await apiInterceptor.put(`${API_ENDPOINTS.ENQUIRY.UPDATE_ENQUIRY_META.replace('{{enquiry_id}}', enquiry_id)}`, data);
  return response;
};

const deleteEnquiryApi = async (id: any): Promise<any> => {
  const response = await apiInterceptor.delete(`${API_ENDPOINTS.ENQUIRY.DELETE_ENQUIRY.replace('{{enquiry_id}}', id)}`);
  return response;
};

const submitDraftApi = async (id: any): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.ENQUIRY.SUBMIT_DRAFT}?enquiry_id=${id}`);
  return response;
};

const getProfileApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.AUTH.PROFILE_GET}`);
  return response;
};

const getTrackingListApi = async (params: any): Promise<any> => {

  let apiParam = ''
  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`
  }

  // if (params?.status && params?.status !== '') {
  //   apiParam = `${apiParam}&status=${params?.status}`
  // }

  if (params?.search && params?.search !== '') {
    apiParam = `${apiParam}&search=${params?.search}`
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.TRACKING.GET_TRACKING_LIST}${apiParam}`);
  return response;
};

const getReturnTrackingListApi = async (params: any): Promise<any> => {

  let apiParam = ''
  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`
  }

  // if (params?.status && params?.status !== '') {
  //   apiParam = `${apiParam}&status=${params?.status}`
  // }

  if (params?.search && params?.search !== '') {
    apiParam = `${apiParam}&search=${params?.search}`
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.TRACKING.GET_RETURN_TRACKING_LIST}${apiParam}`);
  return response;
};



const downloadBundleApi = async (id: any): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.COMMON.DOWNLOAD_BUNDLE.replace('{{event_id}}', id)}`, {
    responseType: 'blob',
  });
  return response;
};

const getOrganisersListApi = async (params: any): Promise<any> => {

  let apiParam = ''
  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`
  }

  if (params?.sortBy && params?.sortBy !== '' && params?.sortOrder && params?.sortOrder !== '') {
    apiParam = `${apiParam}&sort_by=${params?.sortBy}&sort_order=${params?.sortOrder === 'ascend' ? 'asc' : 'desc'}`;
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.COMMON.ORGANISERS_LIST}${apiParam}`);
  return response;
};


const getAllOrganisersListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.ORGANISERS_ALL);
  return response;
};

const getAllEventsListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.EVENTS_ALL);
  return response;
};

const getAllExhibitorsListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.EXHIBITORS_ALL);
  return response;
};

const getExhibitorListApi = async (params: any): Promise<any> => {
  let apiParam = '';

  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`;
  }

  if (params?.sortBy && params?.sortBy !== '' && params?.sortOrder && params?.sortOrder !== '') {
    apiParam = `${apiParam}&sort_by=${params?.sortBy}&sort_order=${params?.sortOrder === 'ascend' ? 'asc' : 'desc'}`;
  }

  const response = await apiInterceptor.post(`${API_ENDPOINTS.COMMON.EXHIBITORS_LIST}${apiParam}`);
  return response;
};


const getStandTypesApi = async (service_type: any, venue: any, region: any): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.STAND_TYPES.replace('{{service_type}}', service_type).replace('{{venue}}', venue).replace('{{region}}', region));
  return response;
};


const getDimensionsListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.DIMENSIONS_LIST);
  return response;
};

const getWeightsListApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.WEIGHT_LIST);
  return response;
};


const validateOrganiserPasscodeApi = async (data: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.ORGANISERS.VALIDATE_ORG_PASSCODE, data);
  return response;
};

const initiatePaymentApi = async (draft_id: any): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.PAYMENT.PAYMENT_INITIATE}?enquiry_id=${draft_id}`);
  return response;
};

const checkPaymentStatusApi = async (draft_id: any): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.PAYMENT.CHECK_STATUS}/${draft_id}`);
  return response;
};

const getPaymentListApi = async (params: any): Promise<any> => {

  let apiParam = '';
  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`;
  }

  let is_pending = false;
  if (params?.is_pending) {
    is_pending = true;
  }

  apiParam = `${apiParam}&is_pending=${is_pending}`;

  const response = await apiInterceptor.get(`${API_ENDPOINTS.PAYMENT.GET_PAYMENT_LIST}${apiParam}`);
  return response;
};

const getPaymentDetailsApi = async (payment_id: any): Promise<any> => {
  const response = await apiInterceptor.get(`${API_ENDPOINTS.PAYMENT.GET_PAYMENT_DETAILS.replace('{{payment_id}}', payment_id)}`);
  return response;
};

const getFeedbacksApi = async (params: any): Promise<any> => {

  let apiParam = '';

  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`;
  }

  if (params?.sortBy && params?.sortBy !== '' && params?.sortOrder && params?.sortOrder !== '') {
    apiParam = `${apiParam}&sort_by=${params?.sortBy}&sort_order=${params?.sortOrder === 'ascend' ? 'asc' : 'desc'}`;
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.ADMIN.GET_FEEDBACKS}${apiParam}`);

  return response;

};

const getAdminDashboardApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.ADMIN.DASHBOARD);
  return response;
};

const getAdminEventShowDashboardApi = async (eventId: string): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.ADMIN.EVENT_SHOW_DASHBOARD, {
    params: { event_id: eventId },
  });
  return response;
};

const saveDashboardLayoutApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.ADMIN.DASHBOARD_LAYOUT, payload);
  return response;
};

const getAdminEventListApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.EVENTS.GET_EVENT_LIST}`, payload);
  return response;
};

const getAdminWHListApi = async (params: any): Promise<any> => {

  let apiParam = '';

  if (params?.page && params?.pageSize) {
    apiParam = `?page=${params?.page}&page_size=${params?.pageSize}`;
  }

  if (params?.sort_by && params?.sort_by !== '' && params?.sort_order && params?.sort_order !== '') {
    apiParam = `${apiParam}&sort_by=${params?.sort_by}&sort_order=${params?.sort_order === 'ascend' ? 'asc' : 'desc'}`;
  }

  const response = await apiInterceptor.get(`${API_ENDPOINTS.WAREHOUSES.GET_WAREHOUSE_LIST}${apiParam}`);
  return response;
};

const createAdminWHApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.WAREHOUSES.CREATE_WAREHOUSE, payload);
  return response;
};

const updateAdminWHApi = async (payload: any, warehouse_id: string): Promise<any> => {
  const response = await apiInterceptor.put(`${API_ENDPOINTS.WAREHOUSES.UPDATE_WAREHOUSE.replace('{{warehouse_id}}', warehouse_id)}`, payload);
  return response;
};

const createAdminEventApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.EVENTS.CREATE_EVENT, payload);
  return response;
};

const updateAdminEventApi = async (payload: any, event_id: string): Promise<any> => {
  const response = await apiInterceptor.put(`${API_ENDPOINTS.EVENTS.UPDATE_EVENT.replace('{{event_id}}', event_id)}`, payload);
  return response;
};

const createAdminOrganiserApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.ORGANISERS.CREATE_ORGANISER, payload);
  return response;
};

const updateAdminOrganiserApi = async (payload: any, organiser_id: string): Promise<any> => {
  const response = await apiInterceptor.put(`${API_ENDPOINTS.ORGANISERS.UPDATE_ORGANISER.replace('{{organiser_id}}', organiser_id)}`, payload);
  return response;
};

const getAdminEnquiriesListApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.ENQUIRY.ENQUIRIES_LIST}`, payload);
  return response;
};

const getEnquiryListSimpleApi = async (payload: any = {}): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.ENQUIRY.ENQUIRIES_LIST_SIMPLE}`, payload);
  return response;
};

const createLabelApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(`${API_ENDPOINTS.ADMIN.CREATE_LABEL}`, payload);
  return response;
};

const getS3UploadUrlApi = async (filepath: string): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.COMMON.GET_S3_UPLOAD_URL.replace('{{filepath}}', filepath));
  return response;
};

// Teams
const getTeamListApi = async (params?: { page?: number; page_size?: number }): Promise<any> => {
  let apiParam = '';
  if (params?.page && params?.page_size) {
    apiParam = `?page=${params.page}&page_size=${params.page_size}`;
  }
  const response = await apiInterceptor.get(`${API_ENDPOINTS.TEAMS.TEAM_LIST}${apiParam}`);
  return response;
};

const addTeamApi = async (payload: { name: string, email: string }): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.TEAMS.ADD_TEAM, payload);
  return response;
};

const updateTeamApi = async (payload: { name: string, email: string, description?: string | null }, team_id: string): Promise<any> => {
  const url = API_ENDPOINTS.TEAMS.UPDATE_TEAM.replace('{{team_id}}', team_id);
  const response = await apiInterceptor.put(url, payload);
  return response;
};

const deleteTeamApi = async (team_id: string): Promise<any> => {
  const response = await apiInterceptor.delete(API_ENDPOINTS.TEAMS.DELETE_TEAM.replace('{{team_id}}', team_id));
  return response;
};

// Members
const getMemberListApi = async (params?: { team_id?: string; page?: number; page_size?: number }): Promise<any> => {
  let apiParam = '';
  if (params?.team_id) {
    apiParam = `?team_id=${params.team_id}`;
  }
  if (params?.page) {
    apiParam += apiParam ? `&page=${params.page}` : `?page=${params.page}`;
  }
  if (params?.page_size) {
    apiParam += apiParam ? `&page_size=${params.page_size}` : `?page_size=${params.page_size}`;
  }
  const response = await apiInterceptor.get(`${API_ENDPOINTS.MEMBERS.MEMBER_LIST}${apiParam}`);
  return response;
};

const addMemberApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.MEMBERS.ADD_MEMBER, payload);
  return response;
};

const updateMemberApi = async (payload: any, member_id: string): Promise<any> => {
  const response = await apiInterceptor.put(API_ENDPOINTS.MEMBERS.UPDATE_MEMBER.replace('{{member_id}}', member_id), payload);
  return response;
};

const deleteMemberApi = async (member_id: string): Promise<any> => {
  const response = await apiInterceptor.delete(API_ENDPOINTS.MEMBERS.DELETE_MEMBER.replace('{{member_id}}', member_id));
  return response;
};


const generateManifestApi = async (payload: any): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.ADMIN.GENERATE_MANIFEST.replace('{{month}}', payload?.month).replace('{{year}}', payload?.year).replace('{{update_drive}}', payload?.update_drive).replace('{{is_download}}', payload?.is_download));
  return response;
};

const generateExcelApi = async (enquiry_id: string, update_method: string): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.EXCEL.GENERATE_EXCEL.replace('{{enquiry_id}}', enquiry_id).replace('{{update_method}}', update_method));
  return response;
};

const processFormWithAutoFormCreationApi = async (file: File, signal?: AbortSignal): Promise<any> => {
  const fd = new FormData();
  fd.append('file', file);
  const response = await apiInterceptor.post(
    API_ENDPOINTS.FUNCTIONS.PROCESS_FORM_WITH_AUTO_FORM_CREATION,
    fd,
    {
      ...(signal ? { signal } : {}),
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );
  return response;
};

const genManifestJSONApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.MASTER.GET_ENQ_JSON);
  return response;
};

const createEnqJsonApi = async (): Promise<any> => {
  const response = await apiInterceptor.get(API_ENDPOINTS.MASTER.CREATE_ENQ_JSON);
  return response;
};

const getAdminFMDashboardApi = async (params: Record<string, unknown>): Promise<any> => {
  const response = await apiInterceptor.get('/admin/fm/dashboard', { params });
  return response;
};

const saveAdminFmLayoutApi = async (payload: unknown): Promise<any> => {
  const response = await apiInterceptor.post(API_ENDPOINTS.ADMIN.FM_LAYOUT, payload);
  return response;
};


export { loginApi, simpleCreateUserApi, simpleUpdateUserApi, sendOtpApi, signupApi, getPhoneCodeApi, verifyOtpApi, getEventListApi, getServiceTypesApi, getCargoTypesApi, getCarriersApi, createCarrierApi, createEnquiryApi, deleteEnquiryApi, submitDraftApi, resetPasswordApi, resendOtpApi, updateDetailsApi, getProfileApi, getTrackingListApi, getReturnTrackingListApi, downloadBundleApi, getOrganisersListApi, getStandTypesApi, getDimensionsListApi, getWeightsListApi, validateOrganiserPasscodeApi, initiatePaymentApi, checkPaymentStatusApi, getPaymentListApi, getPaymentDetailsApi, getFeedbacksApi, getAdminDashboardApi, getAdminEventShowDashboardApi, saveDashboardLayoutApi, getAdminEventListApi, createLabelApi, getAdminEnquiriesListApi, getAllOrganisersListApi, getAllEventsListApi, getAllExhibitorsListApi, getExhibitorListApi, getEnquiryByIdApiV2, updateEnquiryApi, getAdminWHListApi, updateAdminWHApi, createAdminWHApi, createAdminEventApi, updateAdminEventApi, createAdminOrganiserApi, updateAdminOrganiserApi, getS3UploadUrlApi, getTeamListApi, addTeamApi, updateTeamApi, deleteTeamApi, getMemberListApi, addMemberApi, updateMemberApi, deleteMemberApi, generateManifestApi, processFormWithAutoFormCreationApi, generateExcelApi, genManifestJSONApi, createEnqJsonApi, getEnquiryMetaApi, updateEnquiryMetaApi, getEnquiryListSimpleApi, getAdminFMDashboardApi, saveAdminFmLayoutApi, sendOtpToPhoneApi, verifyMobileOtpApi };
